import { useDataProvider, useNotify, useRefresh, useTranslate } from 'react-admin';
import ImportIcon from '@/assets/icons/import-icon.svg?react';
import { CustomButton } from '@/components/global/buttons/CustomButton.jsx';

export const ImportProductButton = ({ id }) => {
    const translate = useTranslate();
    const notify = useNotify();
    const dataProvider = useDataProvider();
    const refresh = useRefresh();

    const handleClick = () => {
        dataProvider
            .post(`product/${id}/import`)
            .then(() => {
                notify(translate('common.productActions.import.success'));
                refresh();
            })
            .catch(error => {
                notify(`${translate('common.errorOccurred')}: ${error.message}`, { type: 'error' });
            });
    };

    return (
        <CustomButton label={translate('common.productActions.import.label')} variant='text' onClick={handleClick}>
            {<ImportIcon />}
        </CustomButton>
    );
};
